// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

import { gsap } from "gsap";

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

function get_elsAfter(nodeList, el_ref) {
  const arr = Array.from(nodeList);
  const idx = arr.indexOf(el_ref);
  return arr.slice(idx + 1);
}

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

const logArgs = { eventName: "stChH_activeGridItem", inline: true, disabled: false };
const msgs = {
  change: (CHANGE) => ["activeGridItem", CHANGE],
};

// —————————————————————————————————————————— HDL. DEF. ——————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default function stChH_activeGridItem(CHANGES) {
  //////////////////////////////////////////// Setup /////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  const { activeGridItem } = CHANGES;
  this.logger("state-change", msgs.change(activeGridItem), "default", logArgs);

  //////////////////////////////////// State change execution ////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  // Find inactive grid items behind/after active grid item (in DOM) //
  const { gridItems } = this.ref;
  // const item_active = gridItems.find((item) => item.dataset.id === activeGridItem);
  // const gridItems_inactive = get_elsAfter(gridItems, item_active);

  // Grid item active setting //
  gridItems.forEach((item) => {
    const is_active = item.dataset.id === activeGridItem;
    item.dataset.active = is_active ? "true" : "false";
    if (activeGridItem != "null") item.dataset.muted = is_active ? "false" : "true";
    else item.dataset.muted = "false"; // Reset muted state when no active item
  });

  ///////////////// Developing grid items open animation /////////////////
  ////////////////////////////////////////////////////////////////////////

  // const gridItem_inactive_first = gridItems_inactive[0];

  // Move first inactive grid item down by 1 row:
  // - each grid item has the same width and height
  // - the height and width of all grid items is dynamic and related to the viewport width
  // - the grid items are arranged in a grid layout in 2 columns

  // const rect_item = item_active.getBoundingClientRect();
  // const { height: h_item, width: w_item } = rect_item;

  // // Calculate the new position of the first inactive grid item
  // const index_inactiveItem = gridItem_inactive_first.dataset.index;
  // const colNum_inactiveItem = index_inactiveItem % 2; // 0 or 1
  // const y_toMoveItemTo = h_item;
  // const x_toMoveItemTo = colNum_inactiveItem === 0 ? 0 : w_item * -1;

  // console.log(`Moving item to: (${x_toMoveItemTo}, ${y_toMoveItemTo})`);

  // gsap.to(gridItem_inactive_first, {
  //   y: y_toMoveItemTo,
  //   x: x_toMoveItemTo,
  //   duration: 1.2,
  //   ease: "power2.out",
  //   onStart: () => (gridItem_inactive_first.dataset.muted = "true"),
  // });
}
